import type { IncomingMessage } from 'http';

import {
  ActionCenterDetails,
  AdvocateCount,
  Nullable,
  SignupDetails,
} from '@/core/interfaces/common';

import { alternateRequest } from '@/utils/alternateRequest';
import { isValidUrl } from '@/utils/helpers';
import { request } from '@/utils/request';
import { viewerIpHeaders } from '@/utils/viewerIp';

// `req` is the incoming SSR request, when there is one, so the backend sees
// the viewer's IP rather than Render's egress IP. The static-JSON
// (`alternateRequest`) branch does not hit the backend, so it is left alone.

export const fetchSingupData = async (
  uuid: string | Array<string> | undefined,
  req?: IncomingMessage
) => {
  if (isValidUrl(process.env.REACT_APP_ACTION_CENTER_ROOT)) {
    return alternateRequest
      .get<Nullable<SignupDetails>>(`${uuid}.json`)
      .then(({ data }) => data)
      .catch(error => null);
  }

  return request
    .get<Nullable<SignupDetails>>(`/public/signup/${uuid}/`, { headers: viewerIpHeaders(req) })
    .then(({ data }) => data)
    .catch(error => null);
};

export const fetchActionCenterData = async (
  uuid: string | Array<string> | undefined,
  req?: IncomingMessage
) => {
  if (isValidUrl(process.env.REACT_APP_ACTION_CENTER_ROOT)) {
    return alternateRequest
      .get<Nullable<ActionCenterDetails>>(`${uuid}.json`)
      .then(({ data }) => data)
      .catch(error => null);
  }

  return request
    .get<Nullable<ActionCenterDetails>>(`/public/act/${uuid}/`, { headers: viewerIpHeaders(req) })
    .then(({ data }) => data)
    .catch(error => null);
};

/*
 Returns an object with the count of advocates for an action center.
 */
export const fetchAdvocatesCount = async (uuid: string | Array<string> | undefined) => request
  .get<Nullable<AdvocateCount>>(`/public/act/${uuid}/advocates-count/`)
  .then(({ data }) => data)
  .catch(error => null);
